'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import { type AnimatedCardStackState, type RefType, useAnimatedCardStackState } from '@/hooks/useAnimatedCardStackState';
import type { CmsTestimonial } from '@/services/cms-sdk';
export type TestimonialsBlockState = {
  cardState$: AnimatedCardStackState<CmsTestimonial>;
  viewPortRef: RefType;
};
const testimonialsBlockContext = createContext<TestimonialsBlockState>(undefined as unknown as TestimonialsBlockState);
export type TestimonialsBlockProviderProps = {
  blockId: ReactNode;
  children: ReactNode;
  testimonials: CmsTestimonial[];
};
export function TestimonialsBlockProvider(t0) {
  const $ = _c(10);
  const {
    blockId,
    children,
    testimonials
  } = t0;
  const [cardState$, keyboardListenerRef, viewPortRef] = useAnimatedCardStackState(testimonials);
  const t1 = `testimonial-provider-${blockId}`;
  let t2;
  if ($[0] !== cardState$ || $[1] !== viewPortRef) {
    t2 = {
      cardState$,
      viewPortRef
    };
    $[0] = cardState$;
    $[1] = viewPortRef;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <testimonialsBlockContext.Provider value={t2}>{children}</testimonialsBlockContext.Provider>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== keyboardListenerRef || $[7] !== t1 || $[8] !== t3) {
    t4 = <div ref={keyboardListenerRef} tabIndex={0} aria-label="Testimonials carousel. Use left and right arrow keys to navigate." className="outline-0" data-testid={t1}>{t3}</div>;
    $[6] = keyboardListenerRef;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function useTestimonialsBlockState() {
  const context = useContext(testimonialsBlockContext);
  if (!context) {
    throw new Error("useTestimonialsBlockState must be used within a Carousel");
  }
  return context;
}